import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../MainContext";
import AddUser from "./AddUser";
import UsersList from "./UsersList";
import { Box } from "@mui/material";
import CollapsableBox from "../../CollapsibleBox/CollapsableBox";

const Users = () => {
    const { darkMode, customers, users, updateUsers, setUsers, openState, boxOpener, isOpen, texts } = useContext(MainContext);

    return (
        <div
            class="relative flex size-full min-h-screen flex-col bg-white group/design-root overflow-x-hidden"
            style={{
                fontFamily: '"Work Sans", "Noto Sans", sans-serif',
                backgroundColor: darkMode ? "black" : "white",
                minHeight: "calc(100vh - 75px)",
            }}
        >
            <div class="layout-container flex h-full grow flex-col">
                <Box>
                    <CollapsableBox title={texts.customer.addUser} isOpen={openState.addUser} setIsOpen={() => boxOpener("addUser")}>
                        <AddUser darkMode={darkMode} isOpen={openState.addUser} updateUsers={updateUsers} texts={texts} />
                    </CollapsableBox>
                </Box>
                <UsersList darkMode={darkMode} customers={customers} users={users} updateUsers={updateUsers} setUsers={setUsers} texts={texts} />
            </div>
        </div>
    );
};

export default Users;
